import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './PortfolioIcon.module.scss';

const PortfolioIcon: FC= () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg"
         width="168"
         height="160"
         fill="none"
         viewBox="0 0 168 160">
      <ellipse cx="84"
               cy="138.5"
               className={styles.overlay}
               rx="84"
               ry="21.5" />
      <path className={styles.skeleton}
            strokeLinecap="round"
            strokeWidth="2"
            d="M131.522 107.965v-5.311" />
      <mask id="path-3-inside-1_19317_55487">
        <path fillRule="evenodd"
              d="M155.368 0c-.697 0-1.263.5655-1.263 1.2632v3.7447h-3.8c-.692 0-1.252.5605-1.252 1.252 0 .6914.56 1.252 1.252 1.252h3.8v3.7446c0 .6976.566 1.2632 1.263 1.2632.698 0 1.264-.5656 1.264-1.2632V7.5118h3.8c.692 0 1.252-.5605 1.252-1.252 0-.6914-.56-1.252-1.252-1.252h-3.8V1.2633c0-.6977-.566-1.2632-1.264-1.2632Z"
              clipRule="evenodd" />
      </mask>
      <path className={styles.star}
            fillRule="evenodd"
            d="M155.368 0c-.697 0-1.263.5655-1.263 1.2632v3.7447h-3.8c-.692 0-1.252.5605-1.252 1.252 0 .6914.56 1.252 1.252 1.252h3.8v3.7446c0 .6976.566 1.2632 1.263 1.2632.698 0 1.264-.5656 1.264-1.2632V7.5118h3.8c.692 0 1.252-.5605 1.252-1.252 0-.6914-.56-1.252-1.252-1.252h-3.8V1.2633c0-.6977-.566-1.2632-1.264-1.2632Z"
            clipRule="evenodd" />
      <path className={styles.star}
            d="M154.105 5.0079v1h1v-1h-1Zm-5.052 1.252h1-1Zm5.052 1.252h1v-1h-1v1Zm2.527 0v-1h-1v1h1Zm0-2.504h-1v1h1v-1Zm-1.527-3.7447c0-.1454.118-.2632.263-.2632v-2c-1.25 0-2.263 1.0132-2.263 2.2632h2Zm0 3.7447V1.2632h-2v3.7447h2Zm-4.8 1h3.8v-2h-3.8v2Zm-.252.252c0-.1392.112-.252.252-.252v-2c-1.244 0-2.252 1.0082-2.252 2.252h2Zm.252.252a.2515.2515 0 0 1-.252-.252h-2c0 1.2437 1.008 2.252 2.252 2.252v-2Zm3.8 0h-3.8v2h3.8v-2Zm1 4.7446V7.5118h-2v3.7447h2Zm.263.2632a.2632.2632 0 0 1-.263-.2632h-2c0 1.2499 1.013 2.2632 2.263 2.2632v-2Zm.264-.2632a.2635.2635 0 0 1-.264.2632v2c1.25 0 2.264-1.0133 2.264-2.2632h-2Zm0-3.7447v3.7447h2V7.5118h-2Zm4.8-1h-3.8v2h3.8v-2Zm.252-.252c0 .1392-.113.252-.252.252v2c1.244 0 2.252-1.0082 2.252-2.252h-2Zm-.252-.252c.139 0 .252.1129.252.252h2c0-1.2437-1.008-2.252-2.252-2.252v2Zm-3.8 0h3.8v-2h-3.8v2Zm-1-4.7446v3.7447h2V1.2632h-2ZM155.368 1c.146 0 .264.1178.264.2632h2c0-1.25-1.014-2.2632-2.264-2.2632v2Z"
            mask="url(#path-3-inside-1_19317_55487)" />
      <mask id="path-5-inside-2_19317_55487">
        <path fillRule="evenodd"
              d="M15.1579 71.3623c-.6976 0-1.2631.5655-1.2631 1.2631v3.7447h-3.8007c-.6914 0-1.252.5605-1.252 1.252 0 .6914.5606 1.2519 1.252 1.2519h3.8007v3.7448c0 .6976.5655 1.2632 1.2631 1.2632.6977 0 1.2632-.5656 1.2632-1.2632V78.874h3.8007c.6914 0 1.2519-.5605 1.2519-1.2519 0-.6915-.5605-1.252-1.2519-1.252h-3.8007v-3.7447c0-.6976-.5655-1.2631-1.2632-1.2631Z"
              clipRule="evenodd" />
      </mask>
      <path className={styles.star}
            fillRule="evenodd"
            d="M15.1579 71.3623c-.6976 0-1.2631.5655-1.2631 1.2631v3.7447h-3.8007c-.6914 0-1.252.5605-1.252 1.252 0 .6914.5606 1.2519 1.252 1.2519h3.8007v3.7448c0 .6976.5655 1.2632 1.2631 1.2632.6977 0 1.2632-.5656 1.2632-1.2632V78.874h3.8007c.6914 0 1.2519-.5605 1.2519-1.2519 0-.6915-.5605-1.252-1.2519-1.252h-3.8007v-3.7447c0-.6976-.5655-1.2631-1.2632-1.2631Z"
            clipRule="evenodd" />
      <path className={styles.star}
            d="M13.8948 76.3701v1h1v-1h-1Zm-5.0526 1.252h1-1Zm5.0526 1.2519h1v-1h-1v1Zm2.5263 0v-1h-1v1h1Zm0-2.5039h-1v1h1v-1Zm-1.5263-3.7447a.2631.2631 0 0 1 .2631-.2631v-2c-1.2499 0-2.2631 1.0132-2.2631 2.2631h2Zm0 3.7447v-3.7447h-2v3.7447h2Zm-4.8007 1h3.8007v-2h-3.8007v2Zm-.252.252a.252.252 0 0 1 .252-.252v-2c-1.2437 0-2.252 1.0082-2.252 2.252h2Zm.252.2519a.252.252 0 0 1-.252-.2519h-2c0 1.2437 1.0083 2.2519 2.252 2.2519v-2Zm3.8007 0h-3.8007v2h3.8007v-2Zm1 4.7448V78.874h-2v3.7448h2Zm.2631.2632a.2632.2632 0 0 1-.2631-.2632h-2c0 1.2499 1.0132 2.2632 2.2631 2.2632v-2Zm.2632-.2632a.2632.2632 0 0 1-.2632.2632v2c1.2499 0 2.2632-1.0133 2.2632-2.2632h-2Zm0-3.7448v3.7448h2V78.874h-2Zm4.8007-1h-3.8007v2h3.8007v-2Zm.2519-.2519a.252.252 0 0 1-.2519.2519v2c1.2437 0 2.2519-1.0082 2.2519-2.2519h-2Zm-.2519-.252a.252.252 0 0 1 .2519.252h2c0-1.2438-1.0082-2.252-2.2519-2.252v2Zm-3.8007 0h3.8007v-2h-3.8007v2Zm-1-4.7447v3.7447h2v-3.7447h-2Zm-.2632-.2631a.2631.2631 0 0 1 .2632.2631h2c0-1.2499-1.0133-2.2631-2.2632-2.2631v2Z"
            mask="url(#path-5-inside-2_19317_55487)" />
      <path className={styles.roundStar}
            strokeWidth="2"
            d="M153.105 36.3071c0 2.2051-1.806 4.0079-4.052 4.0079-2.247 0-4.053-1.8028-4.053-4.0079 0-2.2051 1.806-4.0078 4.053-4.0078 2.246 0 4.052 1.8027 4.052 4.0078Z" />
      <path className={styles.roundStar}
            strokeWidth="2"
            d="M31.8421 55.0866c0 2.2051-1.806 4.0079-4.0527 4.0079-2.2466 0-4.0526-1.8028-4.0526-4.0079 0-2.2051 1.806-4.0079 4.0526-4.0079 2.2467 0 4.0527 1.8028 4.0527 4.0079Z" />
      <path className={styles.roundStar}
            strokeWidth="2"
            d="M4.0526 62.5984c0 .8223-.675 1.504-1.5263 1.504-.8514 0-1.5263-.6817-1.5263-1.504 0-.8222.675-1.5039 1.5263-1.5039.8514 0 1.5263.6817 1.5263 1.5039Z" />
      <path className={styles.roundStar}
            d="M167.5 22.5354c0 1.1026-.903 2.004-2.026 2.004-1.124 0-2.027-.9014-2.027-2.004 0-1.1025.903-2.0039 2.027-2.0039 1.123 0 2.026.9014 2.026 2.0039Z" />
      <path className={classNames(styles.skeleton, styles.background)}
            strokeWidth="2"
            d="M25 116.181h125.579v19.532c0 2.112-1.4 3.507-2.769 3.507H27.7687c-1.369 0-2.7687-1.395-2.7687-3.507v-19.532Z" />
      <path className={styles.skeleton}
            strokeWidth="2"
            d="M37.6316 92.8976h97.7894V36.2238c0-1.4284-1.234-2.6726-2.866-2.6726H40.4972c-1.6315 0-2.8656 1.2442-2.8656 2.6726v56.6738Z" />
      <path className={styles.skeleton}
            strokeWidth="2"
            d="M71.7369 33.0551h29.5791v-6.8395c0-1.8885-1.8553-3.6802-4.4922-3.6802H76.2289c-2.6369 0-4.492 1.7917-4.492 3.6802v6.8395Z" />
      <path className={styles.skeleton}
            strokeWidth="2"
            d="m150.316 115.838-14.527-23.1924H37.8947L25.2631 115.807" />
      <path className={styles.skeleton}
            strokeLinecap="round"
            strokeWidth="2"
            d="M48 82.6299v-40.063h77.053v40.063" />
      <path className={styles.skeleton}
            strokeLinecap="round"
            strokeWidth="2"
            d="m39.1579 115.181 4.2605-7.512h88.0696l4.933 7.512" />
      <path className={styles.skeleton}
            strokeLinecap="round"
            strokeWidth="2"
            d="m125.053 42.5669 3.789-3.7559" />
      <path className={styles.skeleton}
            strokeLinecap="round"
            strokeWidth="2"
            d="m48 42.5669-3.7894-3.7559" />
      <path className={styles.skeleton}
            strokeWidth="2"
            d="M64.2563 126.449H51.9542c-1.4862 0-2.6911 1.121-2.6911 2.504s1.2049 2.504 2.6911 2.504h12.3021c1.4862 0 2.691-1.121 2.691-2.504s-1.2048-2.504-2.691-2.504Z" />
      <path className={styles.skeleton}
            strokeWidth="2"
            d="M123.625 126.449h-12.302c-1.487 0-2.691 1.121-2.691 2.504s1.204 2.504 2.691 2.504h12.302c1.486 0 2.691-1.121 2.691-2.504s-1.205-2.504-2.691-2.504Z" />
      <path className={styles.skeleton}
            strokeLinecap="round"
            strokeWidth="2"
            d="M43.1006 107.973v-5.312" />
      <path className={styles.overlay}
            d="M51.7895 46.3228v35.0551h69.4735V46.3228H51.7895Z" />
      <ellipse cx="92.2105"
               cy="53.8346"
               className={styles.redStar}
               rx="1.2632"
               ry="1.252" />
      <ellipse cx="73.2632"
               cy="101.409"
               className={styles.redStar}
               rx="1.2632"
               ry="1.252" />
      <path className={styles.redRoundStar}
            strokeWidth="2"
            d="M78.5789 86.3858c0 1.5137-1.2404 2.7559-2.7894 2.7559-1.549 0-2.7895-1.2422-2.7895-2.7559s1.2405-2.7559 2.7895-2.7559 2.7894 1.2422 2.7894 2.7559Z" />
      <rect width="2.5263"
            height="12.5197"
            x="96"
            y="72.6141"
            className={styles.redStar}
            rx="1.2632" />
      <rect width="2.5039"
            height="12.6316"
            x="103.579"
            y="77.6221"
            className={styles.redStar}
            rx="1.252"
            transform="rotate(90 103.579 77.6221)" />
      <rect width="1.5158"
            height="7.5118"
            x="81.3474"
            y="62.5984"
            className={styles.redStar}
            rx=".7579" />
      <rect width="1.5024"
            height="7.5789"
            x="85.8948"
            y="65.6031"
            className={styles.redStar}
            rx=".7512"
            transform="rotate(90 85.8948 65.6031)" />
      <path className={styles.overlay}
            d="m44.2105 108.921-3.7894 6.26h94.7369l-4.421-6.26H44.2105Z" />
      <path className={styles.redRoundStar}
            strokeWidth="2"
            d="M92.4737 106.417c0 2.897-2.3716 5.26-5.3158 5.26-2.9442 0-5.3158-2.363-5.3158-5.26 0-2.896 2.3716-5.26 5.3158-5.26 2.9442 0 5.3158 2.364 5.3158 5.26Z" />
    </svg>
  );
};

export default PortfolioIcon;
